import axios from 'src/admin-axios';
import Constants from 'src/constants';

export const support = {
    namespaced: true,
    state: {
      finalIssueList: [],
      ticketContent: {},
      supportTicketChats: [],
    },
    getters: {
      getFinalIssueList (state) {
        return state.finalIssueList;
      },
      getTicketContent (state) {
        return state.ticketContent;
      },
      getSupportTicketChats (state) {
        return state.supportTicketChats;
      },
    },
    mutations: {
      setFinalIssueList (state, data) {
        state.finalIssueList = data;
      },
      setTicketContent (state, data) {
        state.ticketContent = data;
      },
      clearOffTicketContent (state) {
        state.ticketContent = {};
      },
      setSupportTicketChats (state, chats) {
        state.supportTicketChats = chats;
      },
    },
    actions: {
      async createIssueTicket ({ dispatch }, payload) {
        const url = `/support/${payload.appModuleName}/tickets`;
        try {
          await axios.post(url, payload.ticketDetails);
        } catch (exception) {
            dispatch('alert/onAlert', {
                message: 'Something went wrong in creating the ticket.',
                type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
            throw exception;
        }
      },
      async fetchSupportTickets ({ dispatch, commit }, payload) {
        const url = `support/${payload.appModuleName}/tickets`;
        try {
          const response = await axios.get(url, payload.paramDetails);
          commit('setFinalIssueList', response.data);
        } catch (exception) {
            dispatch('alert/onAlert', {
              message: 'Something went wrong in getting all open tickets.',
              type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        }
      },
      async deleteIssueTicket ({ dispatch }, payload) {
        const url = `/support/${payload.appModuleName}/tickets/${payload.ticketId}`;
        try {
            await axios.delete(url);
        } catch (exception) {
            dispatch('alert/onAlert', {
                message: 'Something went wrong in deleting this ticket.',
                type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
            throw exception;
        }
      },
      async fetchTicketContent ({ dispatch, commit }, payload) {
        const url = `support/${payload.appModuleName}/tickets/${payload.ticketId}`;
        try {
            const details = await axios.get(url);
            commit('setTicketContent', details.data);
        } catch (exception) {
            dispatch('alert/onAlert', {
                message: 'Something went wrong in getting the ticket details.',
                type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
        }
      },
      clearTicketContent ({ commit }) {
        commit('clearOffTicketContent');
      },
      async updateIssueTicket ({ dispatch }, payload) {
        const url = `/support/${payload.appModuleName}/tickets/${payload.ticketId}`;
        try {
          await axios.put(url, payload.ticketDetails);
        } catch (exception) {
            dispatch('alert/onAlert', {
                message: 'Something went wrong in updating the ticket.',
                type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
            throw exception;
        }
      },
      async fetchSupportTicketChats ({ dispatch, commit }, payload) {
        const url = `support/${payload.appModuleName}/tickets/${payload.ticketId}/comments`;
        try {
          const response = await axios.get(url);
          commit('setSupportTicketChats', response.data);
        } catch (exception) {
            dispatch('alert/onAlert', {
              message: 'Something went wrong in getting this ticket chats.',
              type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        }
      },
      async sendSupportMessage ({ dispatch }, payload) {
        const url = `support/${payload.appModuleName}/tickets/${payload.ticketId}/comments`;
        try {
          await axios.post(url, payload.messageContent);
        } catch (exception) {
            dispatch('alert/onAlert', {
                message: 'Something went wrong in sending this message.',
                type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
            throw exception;
        }
      },
      async updateIssueFailedStatus ({ dispatch }, payload) {
        const url = `/time-sheets/${payload.issueId}`;
        try {
          await axios.put(url, payload.updatedStatus);
        } catch (exception) {
            dispatch('alert/onAlert', {
                message: 'Something went wrong in updating the status.',
                type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
            throw exception;
        }
      },
    },
};
